/**
 * SetupIntent client secrets are shaped: seti_xxx_secret_yyy
 */
export function getSetupIntentIdFromClientSecret(clientSecret) {
  if (!clientSecret || typeof clientSecret !== 'string') {
    return '';
  }
  const secretMarker = '_secret_';
  const markerIndex = clientSecret.indexOf(secretMarker);
  if (markerIndex > 0) {
    return clientSecret.slice(0, markerIndex);
  }
  if (clientSecret.startsWith('seti_')) {
    return clientSecret;
  }
  return '';
}

export function getSetupIntentIdFromUrlSearchParams(searchParams) {
  const directId = searchParams.get('setup_intent');
  if (directId) {
    return directId;
  }
  const clientSecret = searchParams.get('setup_intent_client_secret');
  return getSetupIntentIdFromClientSecret(clientSecret);
}
